const list = {
  // =================================================================================================================
  components() {
    return [
      {
        component: "search-year",
        label: "계획일",
        value: "year",
        query: { year: "year" },
        options: {
          default: new Date().getFullYear(),
          afterFix: "년",
        },
      },
      {
        component: "search-month",
        label: "월",
        value: "month",
        query: { month: "month" },
        options: {
          default: new Date().getMonth() + 1,
          lastLabel: true,
        },
      },
      {
        component: "search-select-field",
        label: "사업장",
        value: "field",
        query: { f_id: "fieldId", f_name: "fieldName" },
        options: {
          default: { fieldId: "", fieldName: "" },
        },
      },
      {
        component: "search-column-keyword",
        label: "검색조건",
        value: "column",
        query: { ck_t: "head", ck_k: "keyword" },
        options: { hiddenList: ["사업장명", "작성일"] },
      },
    ];
  },
  getConditions: (nav) => {
    const conditions = [];
    const search = nav.value;

    // 검색연도
    let year = Number(search.year || new Date().getFullYear());
    let month = search.month;
    const startDate = new Date(`${year}-${month || "01"}-01`).format("yyyy-MM-dd");
    const endDate = month ? new Date(new Date(startDate).setMonth(new Date(startDate).getMonth() + 1)).format("yyyy-MM-dd") : `${year + 1}-01-01`;
    conditions.push({ key: "body.stdInfo.계획일", operator: ">=", value: startDate });
    conditions.push({ key: "body.stdInfo.계획일", operator: "<", value: endDate });

    // 사업장
    if (search.field) {
      conditions.push({ key: "body.stdInfo.field_id", operator: "=", value: search.field.fieldId });
    }

    //  검색조건
    const heads = list.getHead().map((e) => {
      return { [e.name]: e.key };
    });
    // 배열의 객체들을 하나의 객체로 합치기
    const types = Object.assign({}, ...heads);
    if (search.column && search.column.keyword) {
      conditions.push({ key: types[search.column.head], operator: "LIKE", value: `%${search.column.keyword}%` });
    }
    return conditions;
  },

  getCol: (index, value, func) => {
    try {
      switch (index) {
        case 0:
          return func.getContent(value).stdInfo.field_name; // 사업장명
        case 1:
          return func.getContentTargetList(func.getContent(value).group1); // 점검대상
        case 2:
          return func.getContent(value).stdInfo.writer_name; // 작성자
        case 3:
          return func.getCreatedDate(value.created_at); // 작성일
      }
    } catch (e) {
      /*ignore*/
    }
    return "";
  },

  // =================================================================================================================

  getHead: () => {
    return [{ name: "사업장명" }, { name: "활동대상" }, { name: "작성자" }, { name: "작성일" }];
  },
};

export default list;
